// Copyright (c) 2017 Deere & Company

import PercentageDebit from './percentage-debit';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.tcsm.percentageDebit
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    goBack: parentProps.history.goBack,
    queryParams: parentProps.location.query,
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PercentageDebit);



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/components/index.js